import axios from 'axios';

import {getAuthenticationToken} from 'App/features/user/userApi';
import {BuildrzConfig} from '~/load_config';

export type TPaginatedResponse<T> = {
  num_pages: number;
  num_results: number;
  results: T[];
};

const buildrzAxios = axios.create();

export const initBuildrzAxios = (config: BuildrzConfig): void => {
  buildrzAxios.defaults.baseURL = config.apiOrigin;
  buildrzAxios.defaults.headers.common['Authorization'] =
    getAuthenticationToken();

  buildrzAxios.interceptors.request.use(config => {
    const freshToken = getAuthenticationToken();
    if (buildrzAxios.defaults.headers.common['Authorization'] !== freshToken) {
      buildrzAxios.defaults.headers.common['Authorization'] = freshToken;
      config.headers.Authorization = freshToken;
    }
    return config;
  });
};

export default buildrzAxios;
